import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export const CHECKOUT_URL = 'https://colorpack.online/cart/48306554437771:1?storefront=true';
type CheckoutButtonProps = {
  children: React.ReactNode;
  className?: string;
  compact?: boolean;
};
export function CheckoutButton({
  children,
  className = '',
  compact = false
}: CheckoutButtonProps) {
  return <a href={CHECKOUT_URL} className={`inline-flex w-full items-center justify-center gap-2 rounded-xl bg-orange-500 px-5 text-center font-display font-bold uppercase tracking-wide text-slate-950 shadow-[0_8px_0_#9a3412] transition hover:bg-orange-400 focus:outline-none focus:ring-4 focus:ring-orange-300/40 active:translate-y-1 active:shadow-[0_4px_0_#9a3412] ${compact ? 'py-3 text-sm' : 'py-4 text-base sm:text-lg'} ${className}`} data-id="element-1" data-mp="1nj0oe8cg9lzh">
      <span data-id="element-2" data-mp="330kco47mwye2">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-3" data-mp="330snzro3zvn5" />
    </a>;
}